module.exports = __webpack_public_path__ + "img/vegadapt.1fac5ba3.jpg";